import React, { useState, useEffect, useRef } from 'react';
import { Form, Input, Button, Space, Modal, Row, Col } from 'antd';
import axios from 'axios';
import './index.css';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile,
} from 'react-device-detect';
import ImageLogo from '../../assets/icons/logo.png';
const queryString = require('query-string');
const layout = {
  labelCol: {
    span: 10,
  },
  wrapperCol: {
    span: 5,
  },
};

const tailLayout = {
  wrapperCol: {
    offset: isMobile ? 6 : 10,
    span: 6,
  },
};
const Register = (props) => {
  let history = useHistory();
  const { t, i18n } = useTranslation();
  const [defaultLanguage, setDefaultLanguage] = useState('');
  const userRef = useRef(null);
  const otpReceiveRef = useRef(null);
  useEffect(() => {
    document.title = 'เข้าสู่ระบบ';
    const backurl = queryString.parse(props.location.search, {
      ignoreQueryPrefix: true,
    }).backurl;
    if (!backurl) {
      Modal.error({
        okText: t('close'),
        content: t('backurl_require'),
        onOk: () => {
          window.location.reload();
          // onReset();
        },
      });
    } else {
      setbackURLState(backurl);
    }
    getLanguage();
  }, []);
  const [backURLState, setbackURLState] = useState('');
  const [loading, setloading] = useState(false);
  const [loadingRegister, setloadingRegister] = useState(false);
  const [loadingOTP, setloadingOTP] = useState(false);
  const [tabProcess, setTabProcess] = useState(1);
  const [type, settype] = useState('login');
  const [user, setuser] = useState({});
  const formRef = useRef(null);
  const formRefOTP = useRef(null);
  const formRefOTPLogin = useRef(null);
  const [base64, setbase64] = useState('');

  useEffect(() => {
    setTimeout(() => {
      userRef.current.focus();
    }, 100);
    return () => {};
  }, []);

  const onFinish = async (values) => {
    setuser(values);
    registerApi(values);
  };

  const onFinishOTP = async (values) => {
    otpEnrollmentApi(values);
  };

  const otpEnrollmentApi = async (values) => {
    setloadingOTP(true);
    try {
      const backurl = queryString.parse(props.location.search, {
        ignoreQueryPrefix: true,
      }).backurl;
      values.backurl = backurl ?? '';
      values.username = user.username;
      values.password = user.password;
      console.log(values);
      const result = await axios({
        url: '/Otp/otpEnrollment',
        method: 'post',
        data: values,
      });
      if (result.status === 200) {
        setloadingOTP(false);
        const { data } = result;
        if (data.valid == false) {
          throw 500;
        } else {
          history.push(`/login?backurl=${backURLState}`);
        }
        // await localStorage.setItem('token', result.data);
      }
    } catch (error) {
      console.log(error);
      setloadingOTP(false);
      Modal.error({
        okText: t('close'),
        content: t('otpError'),
        onOk: () => {
          // onReset();
        },
      });
    }
  };

  const registerApi = async (values) => {
    setloadingRegister(true);
    try {
      const backurl = queryString.parse(props.location.search, {
        ignoreQueryPrefix: true,
      }).backurl;
      values.backurl = backurl ?? '';
      const result = await axios({
        url: '/Enrollment',
        method: 'post',
        data: values,
      });
      if (result.status === 200) {
        setloadingRegister(false);
        const { data } = result;
        if (data.userFound == true) {
          Modal.error({
            okText: 'ปิด',
            content: data.message,
            onOk: () => {
              // onReset();
            },
          });
        } else {
          setTabProcess(2);
          otpReceiveRef.current.focus();
          setbase64(data.message);
        }

        // await localStorage.setItem('token', result.data);
      }
    } catch (error) {
      console.log(error);
      setloadingRegister(false);
      Modal.error({
        okText: t('close'),
        content: t('signInError'),
        onOk: () => {
          // onReset();
        },
      });
    }
  };

  const onRegister = async () => {
    settype('register');
    formRef.current.submit();
  };

  const getLanguage = async () => {
    const language = await localStorage.getItem('language');
    if (language === null || language === '') {
      setDefaultLanguage('en');
    } else {
      i18n.changeLanguage(language);
      setDefaultLanguage(language);
    }
  };

  const changeLanguage = async (type) => {
    await localStorage.setItem('language', type);
    i18n.changeLanguage(type);
    setDefaultLanguage(type);
  };

  // const { Header, Footer } = Layout;
  return (
    <div className='antd-login-user-layout-container'>
      <Row style={{ height: '100%' }}>
        {!isMobile && (
          <div
            style={{
              padding: 10,
              backgroundColor: '#fff',
              position: 'absolute',
              display: 'flex',
              zIndex: 999,
              right: 20,
              top: 20,
            }}
          >
            <div
              className={`cursor-pointer language-text ${
                defaultLanguage === 'th' && 'active'
              }`}
              onClick={() => changeLanguage('th')}
            >
              ไทย
            </div>
            <div
              className={`cursor-pointer language-text ${
                defaultLanguage === 'en' && 'active'
              }`}
              style={{ marginLeft: 10 }}
              onClick={() => changeLanguage('en')}
            >
              EN
            </div>
          </div>
        )}
        <Col span={isMobile ? 0 : 6}>
          <div className='scg-background'>
            <div className='antd-pro-layouts-user-layout-header'>
              <div>
                <div alt='logo' />
                <img width={200} src={ImageLogo} />
              </div>
            </div>
          </div>
        </Col>
        <Col span={isMobile ? 24 : 18}>
          {isMobile && (
            <div
              style={{
                padding: 10,
                backgroundColor: '#fff',
                position: 'absolute',
                display: 'flex',
                zIndex: 999,
                right: 20,
                top: 20,
              }}
            >
              <div
                className={`cursor-pointer language-text ${
                  defaultLanguage === 'th' && 'active'
                }`}
                onClick={() => changeLanguage('th')}
              >
                ไทย
              </div>
              <div
                className={`cursor-pointer language-text ${
                  defaultLanguage === 'en' && 'active'
                }`}
                style={{ marginLeft: 10 }}
                onClick={() => changeLanguage('en')}
              >
                EN
              </div>
            </div>
          )}

          {tabProcess == 1 && (
            <div className='antd-pro-layouts-user-layout-content'>
              <div className='antd-pro-layouts-user-layout-top'>
                <Space direction='vertical' size='large'>
                  {isMobile && (
                    <div className='antd-pro-layouts-user-layout-header'>
                      <div>
                        <div alt='logo' />
                        <img
                          src={
                            'https://www.scgpackaging.com/public/frontend/assets/img/icon/logo__scg.svg'
                          }
                        />
                      </div>
                    </div>
                  )}
                  <span className='antd-pro-layouts-user-layout-title'>
                    {t('register')}
                  </span>
                </Space>
              </div>
              <div className='antd-pro-pages-user-login-style-main'>
                <Form
                  {...layout}
                  // {...formItemLayout}
                  // form={form}
                  key={'formRegister'}
                  ref={formRef}
                  name='register'
                  onFinish={onFinish}
                  initialValues={{
                    residence: ['zhejiang', 'hangzhou', 'xihu'],
                    prefix: '86',
                  }}
                  // scrollToFirstError
                >
                  {/* <Space direction="vertical" style={{ width: '100%' }} size="middle"> */}
                  <Form.Item
                    // initialValue={'paper_temp3'}
                    placeholder={t('username')}
                    name='username'
                    label={t('username')}
                    rules={[
                      {
                        required: true,
                        message: t('username_require'),
                      },
                    ]}
                  >
                    <Input
                      ref={userRef}
                      onKeyDown={(e) =>
                        e.keyCode == 13 ? formRef.current.submit() : ''
                      }
                      autoComplete='off'
                    />
                  </Form.Item>
                  <Form.Item
                    // initialValue={'Scg@2020c'}
                    name='password'
                    rules={[
                      {
                        required: true,
                        message: t('password_require'),
                      },
                    ]}
                    label={t('password')}
                  >
                    <Input
                      autoComplete='off'
                      type='password'
                      onKeyDown={(e) =>
                        e.keyCode == 13 ? formRef.current.submit() : ''
                      }
                    />
                  </Form.Item>
                  <Form.Item {...tailLayout}>
                    <Space>
                      <Button
                        loading={loadingRegister}
                        onClick={onRegister}
                        style={{ minWidth: isMobile ? 130 : 130 }}
                        htmlType='button'
                        type='default'
                      >
                        {t('register')}
                      </Button>
                      <Link to={`/login?backurl=${backURLState}`}>
                        <span className='register-link'>{t(`signIn>>`)}</span>
                      </Link>
                    </Space>
                  </Form.Item>
                  {/* </Space> */}
                </Form>
              </div>
            </div>
          )}
          {tabProcess == 2 && (
            <div className='antd-pro-layouts-user-layout-content'>
              <div className='antd-pro-layouts-user-layout-top'>
                <Space direction='vertical' size='large'>
                  <div className='antd-pro-layouts-user-layout-header'>
                    <div>
                      <div alt='logo' />
                      <img
                        src={
                          'https://www.scgpackaging.com/public/frontend/assets/img/icon/logo__scg.svg'
                        }
                      />
                    </div>
                  </div>
                  <span className='antd-pro-layouts-user-layout-title'>
                    Scan QR Code{' '}
                    <span style={{ fontSize: 14, fontWeight: 300 }}>
                      (Microsoft Authenticator)
                    </span>
                  </span>
                  <img
                    height={200}
                    width={200}
                    src={`data:image/jpeg;base64,${base64}`}
                  />
                </Space>
              </div>
              <div
                className='antd-pro-pages-user-login-style-main'
                style={{ marginTop: 0 }}
              >
                <Form
                  {...layout}
                  // {...formItemLayout}
                  // form={form}
                  key={'formOTP'}
                  ref={formRefOTP}
                  name='otp'
                  onFinish={onFinishOTP}
                  // scrollToFirstError
                >
                  {/* <Space direction="vertical" style={{ width: '100%' }} size="middle"> */}
                  <Form.Item
                    initialValue={''}
                    placeholder={t('otpReceive')}
                    name='token'
                    label={t('otpReceive')}
                    rules={[
                      {
                        required: true,
                        message: t('otp_require'),
                      },
                    ]}
                    onKeyDown={(e) =>
                      e.keyCode == 13 ? formRefOTP.current.submit() : ''
                    }
                  >
                    <Input ref={otpReceiveRef} autoComplete='off' />
                  </Form.Item>

                  <Form.Item {...tailLayout}>
                    <Button
                      loading={loadingOTP}
                      style={{ minWidth: 130 }}
                      htmlType='submit'
                      type='default'
                    >
                      {t('confirm')}
                    </Button>
                  </Form.Item>
                  {/* </Space> */}
                </Form>
              </div>
            </div>
          )}
        </Col>
      </Row>
    </div>
  );
};
export default Register;
